/**
 * 四捨五入到小數
 * @param {number} value 
 * @param {number} precision 小數點後X位
 * @returns number
 */
export const ROUND_DECIMAL = (value, precision) => {
    return Math.round(Math.round(value * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, (precision || 0));
}